<template>
  <div>
    <transition name="modal">
      
      <div class="modal" style="display: block">
        <div class="modal-dialog modal-lg" role="document">
          <form @submit.prevent="onSubmit()">
            <div class="modal-content">
              <div class="modal-header abtg__header-modal">
                
                <h5 class="modal-title abtg__modal-title" id="exampleModalLabel2">
                  {{ $t('breadcrumb.map_title') }}</h5>
                
                <div class="tools">
                  <div class="abtg__close-button"><a data-dismiss="modal" @click="closeModal()"><i
                    class="fas fa-times"></i></a></div>
                
                </div>
              
              
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit()" class="">
                  <div class="modal-body">
                    
                    <div class="row">
                      <div class="col-lg-6">
                        <div
                          class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fix-height select-width abtg-select">
                          <label for="region"
                                 class="abtg__label-select">{{ $t('idealista.label_region') }}</label>
                          <select class="mdl-textfield__input abtg__input abtg-select"
                                  tabIndex="-1"
                                  id="region"
                                  @change="changeCities()"
                                  v-model="Regione"
                          >
                            <option :value="region.regione" v-for="region in regionList"
                            >
                              {{ CHANGE_REGION_NAME(region.regione) }}
                            </option>
                          </select>
                        
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div
                          class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fix-height select-width abtg-select">
                          <label
                            class="abtg__label-select">{{ $t('idealista.label_city') }}</label>
                          <select class="mdl-textfield__input abtg__input abtg-select"
                                  tabIndex="-1"
                                  id="cityID"
                                  v-model="formData.cityID"
                          >
                            <option :value="city.id" v-for="city in cityList"
                            >
                              {{ city.comune }}
                            </option>
                          </select>
                        
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input  " name="price"
                                 type="text"
                                 v-model="formData.zone">
                          <label class="mdl-textfield__label abtg__margin-input ">{{ $t('mapping.table_zone') }}</label>
                          <p class="text-danger small" v-if="myErrors.zone">
                            {{ myErrors.zone[0] }}</p>
                        </div>
                      
                      </div>
                      <div class="col">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input" name="price"
                                 type="text"
                                 v-model="formData.macrozone">
                          <label
                            class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.table_macrozone') }}</label>
                        
                        </div>
                      </div>
                      
                      <div class="col">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input" name="price"
                                 type="text"
                                 v-model="formData.microzone">
                          <label
                            class="mdl-textfield__label abtg__label abtg__margin-input">{{ $t('mapping.table_microzone') }}</label>
                        
                        </div>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-lg-12 col-xs-12">
                        <!-- EDIT MODE -->
                        
                        
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input" name="price"
                                 type="text"
                                 v-model="formData.address">
                          <label
                            class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_address') }}</label>
                          <p class="text-danger small" v-if="myErrors.via">
                            {{ myErrors.via[0] }}</p>
                        </div>
                      
                      
                      </div>
                    
                    
                    </div>
                    
                    
                    <!-- Price, Rooms, Floors -->
                    <div class="row">
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                          <input class="mdl-textfield__input abtg__input" name="price"
                                 type="text"
                                 v-model="formData.price" v-money="money">
                          <label
                            class="mdl-textfield__label abtg__margin-input ">{{ $t('mapping.label_price') }}</label>
                          <p class="text-danger small" v-if="myErrors.prezzo">
                            {{ myErrors.prezzo[0] }}</p>
                        </div>
                      
                      
                      </div>
                      
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input" name="room"
                                 type="text"
                                 v-model="formData.room"
                                 v-money="money"
                          >
                          <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_room') }}</label>
                          <p class="text-danger small" v-if="myErrors.locali">
                            {{ myErrors.locali[0] }}</p>
                        </div>
                      
                      
                      </div>
                      
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        >
                          
                          <input class="mdl-textfield__input abtg__input" name="price"
                                 type="text"
                                 v-model="formData.mq"
                                 v-money="money"
                          >
                          <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_mq') }}</label>
                          <p class="text-danger small" v-if="myErrors.mq">
                            {{ myErrors.mq[0] }}</p>
                        </div>
                      
                      
                      </div>
                      
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input" name="floor"
                                 type="text"
                                 v-model="formData.floor"
                                 v-money="money"
                          >
                          <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_floor') }}</label>
                          <p class="text-danger small" v-if="myErrors.piano">
                            {{ myErrors.piano[0] }}</p>
                        </div>
                      
                      
                      </div>
                    </div>
                    
                    <!-- Lift, Bathroom, Renovation-->
                    <div class="row">
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input" name="lift"
                                 type="text"
                                 v-model="formData.lift">
                          <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_lift') }}</label>
                          <p class="text-danger small" v-if="myErrors.ascensori">
                            {{ myErrors.ascensori[0] }}</p>
                        </div>
                      
                      
                      </div>
                      
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        
                        >
                          <input class="mdl-textfield__input abtg__input" name="bathroom"
                                 type="text"
                                 v-model="formData.bathroom"
                                 v-money="money">
                          <label
                            class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_bathroom') }}</label>
                          <p class="text-danger small" v-if="myErrors.bagni">
                            {{ myErrors.bagni[0] }}</p>
                        </div>
                      
                      
                      </div>
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        >
                          <input class="mdl-textfield__input abtg__input" name="renovation"
                                 type="text"
                                 v-model="formData.renovation">
                          <label
                            class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_renovation') }}</label>
                          <p class="text-danger small" v-if="myErrors.ristrutturazione">
                            {{ myErrors.ristrutturazione[0] }}</p>
                        </div>
                      
                      
                      </div>
                      
                      <div class="col-lg-3 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        >
                          <date-picker v-model="myDate" lang="it" placeholder=""
                                       format="DD/MM/YYYY"></date-picker>
                          
                          <label class="mdl-textfield__label abtg__margin-input" style="margin-top:-20px;">Data</label>
                          <p class="text-danger small abtg__error-select" v-if="myErrors.data">
                            {{ myErrors.data[0] }}</p>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Date, Link, Note-->
                    <div class="row">
                      
                      <div class="col-lg-12 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        >
                          
                          <input class="mdl-textfield__input abtg__input" name="link"
                                 type="text"
                                 v-model="formData.link">
                          <label class="mdl-textfield__label abtg__margin-input">{{ $t('mapping.label_link') }}</label>
                          <p class="text-danger small" v-if="myErrors.link">
                            {{ myErrors.link[0] }}</p>
                        </div>
                      
                      
                      </div>
                    
                    </div> <!-- // end row -->
                    <div class="row">
                      <div class="col-lg-12 col-xs-12">
                        <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width"
                        >
                                    <textarea class="mdl-textfield__input abtg__input" name="note" type="text"
                                              v-model="formData.note"></textarea>
                          
                          <label class="mdl-textfield__label abtg__margin-input"
                          >{{ $t('mapping.label_note') }}</label>
                          <p class="text-danger small" v-if="myErrors.note">
                            {{ myErrors.note[0] }}</p>
                        </div>
                      
                      
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <!-- EDIT MODE -->
                        
                        <button type="submit"
                                class="  margin-right-10 btn-success float-right abtg__btn-star"
                        
                        >
                          SALVA
                        </button>
                        
                        
                        <save-ok v-bind:content="{isItOk: saveOk}"></save-ok>
                      
                      </div>
                    </div> <!-- // end row -->
                  </div>
                </form>
              
              </div>
              <div class="modal-footer abtg__header-modal-footer">
              </div>
            </div>
          </form>
        </div>
      </div>
    
    </transition>
  </div>
</template>


<script>
import Modal from '../../components/commons/modal';
import {mixin} from '../../helpers/helper'
import {Money} from 'v-money';
import {createHelpers} from 'vuex-map-fields';
import saveOk from '../commons/saveok';
import DatePicker from 'vue2-datepicker';

const {mapFields} = createHelpers({
  getterType: 'custom/getField',
  mutationType: 'custom/updateField',
});

export default {
  props: ['content'],
  mixins: [mixin],
  components: {Money, Modal, saveOk, DatePicker},
  data: function () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  
  computed: {
    ...mapFields(['showModal', 'formData', 'myErrors', 'saveOk', 'Regione', 'regionList', 'cityList', 'myDate',
    
    ]),
  },
  created: function () {
    this.regionList();
    this.formData.price = this.content.mappedBuilding.prezzo;
    this.formData.address = this.content.mappedBuilding.via;
    this.formData.zone = this.content.mappedBuilding.zone;
    this.formData.macrozone = this.content.mappedBuilding.macrozone;
    this.formData.microzone = this.content.mappedBuilding.microzone;
    this.formData.room = this.content.mappedBuilding.locali;
    this.formData.mq = this.content.mappedBuilding.mq;
    this.formData.floor = this.content.mappedBuilding.piano;
    this.formData.lift = this.content.mappedBuilding.ascensori;
    this.formData.bathroom = this.content.mappedBuilding.bagni;
    this.formData.renovation = this.content.mappedBuilding.ristrutturazione;
    this.formData.link = this.content.mappedBuilding.myLink;
    this.formData.note = this.content.mappedBuilding.note;
  },
  methods: {
    onSubmit: function () {
      this.$parent.onSubmit();
    },
    closeModal: function () {
      this.$parent.showHideModal();
    },
    regionList: function () {
      this.$store.dispatch('custom/regionList');
      
      
    },
    changeCities: function () {
      this.$store.dispatch('custom/cityList');
    }
    
  }
}
</script>